module.exports = __webpack_public_path__ + "static/media/stars.f509af88.svg";